import React from 'react';
import {NavLink} from 'react-router-dom';


import * as styleUtils from '../../../../../utils/styleUtils';

import {registrationConstants} from '../../../Registration';

import {I18nMessage} from '../../../../contexts/I18n';
import {Icon, iconConstants} from '../../../../global/Icon';
import {MoodWall} from '../../../../global';
import {StandardLayout} from '../../../../layouts';
import {assetUrl} from '../../../../../utils/cdnUtils';

import styles from '../../Static.scss';
import TransactionVolumes from '../../components/TransactionVolumes';
import ServicesRow from '../../components/ServicesRow';


export default function HomePage() {

    return (
        <StandardLayout>

            <div className={styles.landingStatic}>

                <section className={styleUtils.toClasses(styles.marketRow, 'container')}>
                    <div className={'row'}>

                        <div className={'col-6'}>
                            <h1>
                                <I18nMessage id={'page.start.static.market.headline'}/>
                            </h1>
                            <p>
                            <span className={styles.corporateName}>
                                <I18nMessage id={'corporate.name'}/>
                            </span>
                                &nbsp;
                                <I18nMessage id={'page.start.static.market.sub'}/>
                            </p>
                            <p>
                                <NavLink
                                    className={styles.linkRegister}
                                    to={registrationConstants.NAV_REGISTRATION_BASE}
                                >
                                    <I18nMessage id={'page.start.static.link.register.text'}/>
                                    <Icon icon={iconConstants.ICON_NEXT}/>
                                </NavLink>
                            </p>
                        </div>

                        <div className={'col-6'}>
                            <img
                                alt={''}
                                src={assetUrl('/images/market.webp')}
                                height={427}
                                width={954}/>
                        </div>

                    </div>
                </section>

                <MoodWall>

                    <div className={'row value-generation'}>

                        <div className={'col-6'}>

                            <img
                                alt={'Trade image'}
                                height={330}
                                src={assetUrl('/images/mood/mood-value-trade.svg')}
                                width={226}
                            />

                        </div>
                        <div className={'col-6'}>

                            <h1>
                                <I18nMessage id={'page.start.static.value.headline.part1'}/>
                                <br/>
                                <I18nMessage id={'page.start.static.value.headline.part2'}/>
                            </h1>
                            <h2>
                                <I18nMessage id={'page.start.static.value.sub'}/>
                            </h2>
                            <div className={'text-wrap'}>
                                <p className={styles.condensed}>
                                    <I18nMessage id={'page.start.static.value.text1'}/>
                                </p>
                                <p className={styles.condensed}>
                                    <I18nMessage id={'page.start.static.value.text2'}/>
                                </p>
                            </div>

                        </div>

                    </div>

                </MoodWall>


                <TransactionVolumes/>


                <ServicesRow/>


                <section className={styleUtils.toClasses(styles.joinRow, 'container')}>
                    <div className={'row'}>

                        <div className={'col-6'}>
                            <img
                                alt={''}
                                height={368}
                                src={assetUrl('/images/mood/mood-sign-up.svg')}
                                width={440}
                            />
                        </div>

                        <div className={'col-6'}>
                            <h1>
                                <I18nMessage id={'page.start.static.register.headline.line1'}/>
                                <br />
                                <I18nMessage id={'page.start.static.register.headline.line2'}/>
                            </h1>

                            <p>
                                <NavLink
                                    className={styles.linkRegister}
                                    to={registrationConstants.NAV_REGISTRATION_BASE}
                                >
                                    <I18nMessage id={'page.start.static.link.register.text'}/>
                                    <Icon icon={iconConstants.ICON_NEXT}/>
                                </NavLink>
                            </p>
                        </div>

                    </div>
                </section>

            </div>

        </StandardLayout>
    );
}
